module.exports = __webpack_public_path__ + "img/animationArrowWhite.3af81439.svg";